import { Button } from 'antd'
import React from 'react'
import { noop } from '../../utils/helper'

const GetFreeNumberSuccess = (props) => {
  const { number, onOkClick = noop } = props
  return (
    <div className="text-center wp">
      <h2 className="text-blue tip">You get a new fax number</h2>
      <div className="num font-bold" style={{ fontSize: '24px' }}>
        {number}
      </div>
      <br />
      <p className="info">Now you can use it to send a fax online</p>
      <br />
      <Button type="primary" size="large" onClick={onOkClick}>
        Try It Now
      </Button>
    </div>
  )
}

export default GetFreeNumberSuccess
